import React, { useEffect, useState } from "react";
import Aceite from "../../TraineeArea/aceite";
import style from "./style.module.css";
import Header from "../../../components/Header";
import HeaderTrainee from "../../../components/HeaderTrainee";
import useWrapper from "../../../hooks/useWrapper";
import { Outlet } from "react-router-dom";
import { Main, Content, SubContent, Wrapper } from "../../../components/Layout";
import Ad from "../../../components/Ad";

export default function TraineeAreaLayout() {
  const { me, loadMe } = useWrapper();
  const [reload, setreload] = useState(false);
  useEffect(() => {
    !me && loadMe();
  }, [reload]);

  return (
    <>
      {me && (
        <>
          <Header fullNav={true} />
          <div className={style.userArea}>
            <Main>
              <Content noBG="true">
                {me.aceite_virtual ? <Outlet /> : <Aceite reload={reload} setreload={setreload} />}
              </Content>
            </Main>
          </div>
          <Ad />
        </>
      )}
    </>
  );
}
